import { IconButton } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

export const SmallIconButton = withDefaultProps(IconButton, { size: "small" });
